import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getExtranetApi } from '../extranetApi';

export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => getExtranetApi().delete<Record<string, never>, void>(`/v1/extranet/users/${id}`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['extranet', 'users'] });
    },
  });
};
